import { ACTIONS_FROM_WHITE_LABEL } from '../../constants'

const initialWhiteLabelState = {
   whiteLabelEnabled: false,
   imageFormat: 'svg',
   login: undefined,
   header: undefined,
   about: undefined
}

const whiteLabelState = (state = initialWhiteLabelState, action) => {
   switch (action.type) {
      case ACTIONS_FROM_WHITE_LABEL.SET_CUSTOM_IMAGES:
         return {
            ...state,
            whiteLabelEnabled: action.whiteLabelEnabled,
            imageFormat: action.imageFormat,
            login: action.login,
            header: action.header,
            about: action.about
         }
      default:
         return state;
   }
}

export default whiteLabelState


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_white_label.js